<div class="bg cust-login-bg">
    <div class="container">
        <div class="content-wrap">
            <div class="row">
                <div class="col-md-4">
                    <img src="assets/images/logo.png" class="logo" alt="logo">
                    <div class="blue-wrap bg-theme">
                        <h2 class="info-hd">Information</h2>
                        <p class="info-line">By registering as Employer / Third Party you can verify education documents
                            of your
                            employers / Third Party.</p>
                        <p class="info-line">By registering as Employer / Third Party you can verify education documents
                            of your
                            employers / Third Party.</p>
                        <p class="info-line"><a class="status-line" target="_blank"
                                href="assets/images/employerusermanual.pdf">USER MANUAL</a></p>
                    </div>
                </div>
                <div class="col-md-8">
                    <h1 class="page-hd"> Third Party Registration</h1>
                    <div class="container">
                        <form [formGroup]="registerEmployeeForm">
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="firstName" class="form-label">First Name <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your First Name" formControlName="firstName"
                                        class="form-control form-input" [(ngModel)]="RegisterEmployee.firstName"
                                        [ngClass]="{'is-invalid': submitted && f.firstName.errors }" />
                                    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                        <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                    </div>
                                </div>
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="lastName" class="form-label">Last Name <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your Last Name" formControlName="lastName"
                                        class="form-control form-input" id="lastName"
                                        [(ngModel)]="RegisterEmployee.lastName"
                                        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                                    <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                        <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="companyName" class="form-label">Company Name <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your Company Name"
                                        [(ngModel)]="RegisterEmployee.companyName" class="form-control form-input"
                                        id="companyName" formControlName="companyName"
                                        [ngClass]="{'is-invalid': submitted && f.companyName.errors }" />
                                    <div *ngIf="submitted && f.companyName.errors" class="invalid-feedback">
                                        <div *ngIf="f.companyName.errors.required">Company Name is required</div>
                                    </div>
                                </div>
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="emailId" class="form-label">Company Email <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your Email" formControlName="emailId"
                                        [(ngModel)]="RegisterEmployee.emailId" class="form-control form-input"
                                        id="emailId" [pattern]="emailPattern"
                                        [ngClass]="{ 'is-invalid': submitted && f.emailId.invalid}" required emailId />
                                    <div *ngIf="submitted &&  f.emailId.invalid" class="invalid-feedback">
                                        <div *ngIf="f.emailId.errors.required">Email Id is required</div>
                                        <div *ngIf="f.emailId.errors.pattern">Email must be a valid email address
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <!-- <div class="form-group input-group-lg col-sm-6">
                                    <label for="contactPersonName" class="form-label">Contact Person Name <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter the Contact Person Name"
                                        formControlName="contactPersonName"
                                        [(ngModel)]="RegisterEmployee.contactPersonName" class="form-control form-input"
                                        id="contactPersonName"
                                        [ngClass]="{'is-invalid': submitted && f.contactPersonName.errors }" />
                                    <div *ngIf="submitted && f.contactPersonName.errors" class="invalid-feedback">
                                        <div *ngIf="f.contactPersonName.errors.required">Contact Person Name is required
                                        </div>
                                    </div>
                                </div> -->
                                <div class="form-group input-group col-sm-6">
                                    <label for="contactPersonPhoneNo" class="form-label">Phone No. <span
                                            class="color-red">*</span></label>
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">+91</span>
                                    </div>
                                    <input type="text" placeholder="Enter your Phone no." formControlName="phoneNumber"
                                        class="form-control form-input" id="phoneNumber"
                                        [(ngModel)]="RegisterEmployee.phoneNumber" (keypress)="keyPress($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }" />
                                    <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                                        <div *ngIf="f.phoneNumber.errors.required">Phone No. is required</div>
                                        <div
                                            *ngIf="f.phoneNumber.errors.pattern || f.phoneNumber.errors.maxlength || f.phoneNumber.errors.minlength">
                                            Phone number must be at least 10 numbers
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="password" class="form-label">Password <span
                                            class="color-red">*</span></label>
                                    <input type="password" placeholder="Create your Password" formControlName="password"
                                        class="form-control form-input" id="password"
                                        [(ngModel)]="RegisterEmployee.password"
                                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                        [ngClass]="{ 'is-invalid': submitted && f.password.invalid }" minlength="6">
                                    <div *ngIf="submitted && f.password.invalid" class="invalid-feedback">
                                        <div *ngIf="f.password.errors.required">Password is required</div>
                                        <!-- <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div> -->
                                        <div *ngIf="f.password.errors.pattern"> Must contain at least one number and one
                                            uppercase and lowercase letter, and at least 8 or more characters.</div>
                                    </div>
                                </div>
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="rePassword" class="form-label">Confirm Password <span
                                            class="color-red">*</span></label>
                                    <input type="password" placeholder="Confirm your Password"
                                        formControlName="rePassword" class="form-control form-input" id="rePassword"
                                        pattern="{{f.password.value }}"
                                        [ngClass]="{ 'is-invalid': submitted && f.rePassword.invalid }">
                                    <div *ngIf="submitted && f.rePassword.invalid" class="invalid-feedback">
                                        <div *ngIf="f.rePassword.errors.required">Confirm Password is required</div>
                                        <div *ngIf="f.rePassword.errors.pattern"> Password & Confirm Password does not
                                            match.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="gstNo" class="form-label">GST No. <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your GST No." formControlName="gstNo"
                                        [(ngModel)]="RegisterEmployee.gstNo"
                                        oninput="this.value = this.value.toUpperCase()" class="form-control form-input"
                                        id="gstNo" [pattern]="JSTNumber"
                                        [ngClass]="{'is-invalid': submitted && f.gstNo.errors }" />
                                    <div *ngIf="submitted && f.gstNo.errors" class="invalid-feedback">
                                        <div *ngIf="f.gstNo.errors.required">GST no. is required</div>
                                        <div *ngIf="f.gstNo.errors.pattern">Not a valid GST number!</div>
                                    </div>
                                </div>
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="panNumber" class="form-label">PAN No. <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your PAN No." formControlName="panNumber"
                                        [(ngModel)]="RegisterEmployee.panNumber" [pattern]="PANNoPattern"
                                        class="form-control form-input" id="panNumber"
                                        oninput="this.value = this.value.toUpperCase()"
                                        [ngClass]="{'is-invalid': submitted && f.panNumber.errors }" />
                                    <div *ngIf="submitted && f.panNumber.errors" class="invalid-feedback">
                                        <div *ngIf="f.panNumber.errors.required">PAN no. is required</div>
                                        <div *ngIf="f.panNumber.errors.pattern">Not a valid Pan number!</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="areYouGov" class="form-label">Are you a Government of India / State Government entity / department <span
                                            class="color-red">*</span></label>
                                    <select class="form-control form-input" formControlName="areYouGov" [(ngModel)]="RegisterEmployee.areYouGov" 
                                    [ngClass]="{'is-invalid': submitted && f.areYouGov.errors}" id="areYouGov" (change)="areYouGovChange($event.target.value)">
                                        <option value="Y">Yes</option>
                                        <option value="N">No</option>
                                    </select>
                                    <div *ngIf="submitted && f.areYouGov.errors" class="invalid-feedback">
                                        <div *ngIf="f.areYouGov.errors.required">Value is required</div>
                                    </div>
                                </div>
                                <div class="form-group input-group-lg col-sm-6" >
                                    <label for="gstExemption" class="form-label">If Yes selected, Are you eligible for exemption from paying GST for this service <span
                                        class="color-red">*</span></label>
                                    <select class="form-control form-input" formControlName="gstExemption"
                                     [(ngModel)]="RegisterEmployee.gstExemption" [ngClass]="{'is-invalid': submitted && f.gstExemption.errors}" id="gstExemption" (change)="gstExemptionChange($event.target.value)">
                                        <option value="Y">Yes</option>
                                        <option value="N">No</option>
                                    </select>
                                    <!-- <div *ngIf="submitted && f.gstExemption.errors" class="invalid-feedback">
                                        <div *ngIf="f.gstExemption.errors.required">Value is required</div>
                                    </div> -->
                                </div>
                                <!-- <div class="form-group input-group-lg col-sm-6">
                                    <label for="areYouGov" class="form-label">Where Do you Need verification For? <span
                                            class="color-red">*</span></label>
                                    <select class="form-control form-input" formControlName="areYouGov" [(ngModel)]="RegisterEmployee.areYouGov" [ngClass]="{'is-invalid': submitted && f.areYouGov.errors}" id="areYouGov" (change)="areYouGovChange($event.target.value)">
                                        <option value="Y">Dubai Embassy</option>
                                        <option value="N">Deomestic</option>
                                    </select>
                                    <div *ngIf="submitted && f.areYouGov.errors" class="invalid-feedback">
                                        <div *ngIf="f.areYouGov.errors.required">Value is required</div>
                                    </div>
                                </div> -->
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="pincode" class="form-label">Pincode <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your Pincode" formControlName="pincode"
                                        [(ngModel)]="RegisterEmployee.pincode" class="form-control form-input"
                                        id="pincode"
                                        [ngClass]="{'is-invalid': submitted && f.pincode.errors }" />
                                    <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                                        <div *ngIf="f.pincode.errors.required">Pincode is required</div>
                                    </div>
                                </div>
                                 <div class="form-group input-group-lg col-sm-6">
                                    <label for="city" class="form-label">City <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your City" formControlName="city"
                                        [(ngModel)]="RegisterEmployee.city"
                                        class="form-control form-input" id="city"
                                        [ngClass]="{'is-invalid': submitted && f.city.errors }" />
                                    <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                        <div *ngIf="f.city.errors.required">City is required</div>
                                    </div>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="state" class="form-label">State <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your State" formControlName="state"
                                        [(ngModel)]="RegisterEmployee.state" class="form-control form-input"
                                        id="state"
                                        [ngClass]="{'is-invalid': submitted && f.state.errors }" />
                                    <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                        <div *ngIf="f.state.errors.required">State is required</div>
                                    </div>
                                </div>
                                 <div class="form-group input-group-lg col-sm-6">
                                    <label for="country" class="form-label">Country <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your Country" formControlName="country"
                                        [(ngModel)]="RegisterEmployee.country"
                                        class="form-control form-input" id="country"
                                        [ngClass]="{'is-invalid': submitted && f.country.errors }" />
                                    <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                        <div *ngIf="f.country.errors.required">Country is required</div>
                                    </div>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="form-group input-group-lg col-sm-6">
                                    <label for="address" class="form-label">Address <span
                                            class="color-red">*</span></label>
                                    <input type="text" placeholder="Enter your Address" formControlName="address"
                                        [(ngModel)]="RegisterEmployee.address" class="form-control form-input"
                                        id="address"
                                        [ngClass]="{'is-invalid': submitted && f.address.errors }" />
                                    <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                                        <div *ngIf="f.address.errors.required">Address is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 mt-2">
                                    <!-- AWS key -->
                                    <re-captcha (resolved)="resolved($event)"
                                        [siteKey]="recaptchaSiteKey"></re-captcha>
                                        <!-- internal server key -->
                                        <!-- <re-captcha (resolved)="resolved($event)"
                                        siteKey="6Lc80SEjAAAAAHqStbc67KR31WlGv5RSmXlvrwop"></re-captcha> -->
                                </div>
                            </div>
                            <div class="col-md-6  col-md-offset-5 ">
                                <label id="invalidCaptcha"
                                    style="color:#dc3545;font-size:80% ;">{{invalidCaptcha}}</label>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <div class="col-sm-6 mt-2">
                                    <label><input type="checkbox" formControlName="cb"> <span class="agree-text">I agree
                                            to the <a class="agree-link color-theme" data-toggle="modal"
                                                data-target="#termsModal">
                                                Terms & Conditions</a></span> </label>
                                    <div *ngIf="submitted && f.cb.errors" class="invalid-feedbackChk">
                                        <div *ngIf="f.cb.errors.required">Please check terms and condition </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-md-9  col-md-offset-5 ">
                                <label id="submitMessage"
                                    style="color:#dc3545;font-size:100% ;">{{submitMessage}}</label>
                            </div>
                            <div class="form-group">
                                <button class="btn bg-theme color-white form-btn" (click)="submitForm()"
                                    data-toggle="modal" data-target="#successModal">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="clear-both"></div>

<app-footer></app-footer>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header bg-theme success-modal-header2">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">Email is sent to you for verification. Please verify your mail.</p>
                </div>
            </div>
            <button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="modal fade" id="termsModal" tabindex="-1" role="dialog" aria-labelledby="termsModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-theme">
                <h5 class="modal-title" id="termsModal">Terms & Conditions</h5>
                <button type="button" #closebutton class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <ol class="terms-ul">
                            <li class="reset-hd">Lorum ipsum kolo donar is te documet required donar kolo firok tegr.
                            </li>
                            <li class="reset-hd">Kpsum kolo donar is te documet required donar kolo firok tegr donar is
                                te documet required. donar is te documet required donar kolo firok tegr donar</li>
                            <li class="reset-hd">Doan kolo donar is te documet required donar kolo firok tegr donar is
                                te documet required.</li>
                            <li class="reset-hd">Kolo ipsum kolo donar is te documet required donar kolo firok tegr.
                            </li>
                            <li class="reset-hd">Lorum ipsum kolo donar is te documet required donar kolo firok tegr.
                                ipsum kolo donar is te documet required donar kolo firok tegr. onar is te documet
                                required donar kolo firok tegr. ipsum kolo donar is te documet required donar kolo firok
                                tegr.</li>
                            <li class="reset-hd">Kpsum kolo donar is te documet required donar kolo firok tegr donar is
                                te documet required. onar is te documet required donar kolo firok tegr. ipsum kolo donar
                                is te documet required donar kolo firok tegr.</li>
                            <li class="reset-hd">Doan kolo donar is te documet required donar kolo firok tegr donar is
                                te documet required.</li>
                            <li class="reset-hd">Kolo ipsum kolo donar is te documet required donar kolo firok tegr.
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>